import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle, LinkClickHandlerSymbol } from '@wix/thunderbolt-symbols'
import { SamePageScroll } from './dsSamePageScroll'
import {
	AnchorCompIdProviderSymbol,
	SamePageAnchorPropsResolverSymbol,
	SamePageScrollSymbol,
	ScrollToAnchorHandlerProviderSymbol,
} from '../symbols'
import { SamePageScrollClickHandler } from '../samePageScrollClickHandler'
import { ScrollToAnchorHandlerProvider } from '../scrollToAnchorHandlerProvider'
import { AnchorDataItCompIdProvider } from './dsAnchorCompIdProvider'
import { PostNavigationScroll } from '../postNavigationScroll'
import { SamePageAnchorHrefUpdater } from '../samePageAnchorHrefUpdater'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { SamePageAnchorHrefHandlersImplementor } from './samePageAnchorHrefHandlersImplementor'
import { SamePageAnchorPropsResolver } from '../samePageAnchorPropsResolver'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ModelUpdatesHandlersImplementor).to(SamePageAnchorHrefHandlersImplementor)
	bind(SamePageAnchorPropsResolverSymbol).to(SamePageAnchorPropsResolver)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(SamePageScrollSymbol).to(SamePageScroll)
	bind(LifeCycle.AppDidLoadPageHandler).to(PostNavigationScroll)
	bind(LinkClickHandlerSymbol).to(SamePageScrollClickHandler)
	bind(ScrollToAnchorHandlerProviderSymbol).to(ScrollToAnchorHandlerProvider)
	bind(AnchorCompIdProviderSymbol).to(AnchorDataItCompIdProvider)
	bind(LifeCycle.PageWillMountHandler).to(SamePageAnchorHrefUpdater)
}
